import {ID, V2_COMPARTMENT_LTM, V2_COMPARTMENT_SKIP_LTM} from './constants';
import type {V2BaseToken} from './types';

export default function getIdFromToken(token: V2BaseToken) {
  const ltm = token[V2_COMPARTMENT_LTM];

  if (ltm && !token[V2_COMPARTMENT_SKIP_LTM]) {
    return ltm;
  }

  return token[ID];
}
